import React, { useState, useEffect } from 'react';
import api from '../api';
import { useToast } from '../Toast';
import { invalidateStatusCache } from '../useStatuses';

const SYSTEM_KEYS = ['draft','needs_info','pending','approved','needs_update','withdrawn'];

export default function StatusesPage() {
  const [statuses, setStatuses] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [form, setForm] = useState({ label: '', color: '#3b82f6' });
  const [saving, setSaving] = useState(false);
  const toast = useToast();

  useEffect(() => { load(); }, []);

  async function load() {
    try { const r = await api.get('/settings/statuses'); setStatuses(r.data); }
    catch { toast('Błąd ładowania statusów', 'error'); }
  }

  function openNew() { setEditItem(null); setForm({ label: '', color: '#3b82f6' }); setShowModal(true); }
  function openEdit(s) { setEditItem(s); setForm({ label: s.label, color: s.color }); setShowModal(true); }

  async function save(e) {
    e.preventDefault();
    setSaving(true);
    try {
      if (editItem) {
        await api.put(`/settings/statuses/${editItem.id}`, form);
        toast('Status zaktualizowany');
      } else {
        await api.post('/settings/statuses', form);
        toast('Status dodany');
      }
      setShowModal(false);
      invalidateStatusCache();
      load();
    } catch (err) {
      toast(err.response?.data?.error || 'Błąd zapisu', 'error');
    } finally { setSaving(false); }
  }

  async function del(s) {
    if (s.is_system) { toast('Nie można usunąć systemowego statusu', 'error'); return; }
    if (!window.confirm(`Usunąć status "${s.label}"?`)) return;
    try { await api.delete(`/settings/statuses/${s.id}`); invalidateStatusCache(); toast('Usunięto'); load(); }
    catch (err) { toast(err.response?.data?.error || 'Błąd', 'error'); }
  }

  return (
    <div style={{ maxWidth: 860, margin: '0 auto', padding: '28px 16px' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700 }}>Statusy procedur</h1>
          <p style={{ margin: '4px 0 0', color: 'var(--gray-500)', fontSize: 14 }}>
            Zarządzaj statusami i ich kolorami. Statusy systemowe można edytować, ale nie usunąć.
          </p>
        </div>
        <button className="btn btn-primary" onClick={openNew}>+ Nowy status</button>
      </div>

      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        {statuses.length === 0 ? (
          <div style={{ padding: 32, textAlign: 'center', color: 'var(--gray-400)' }}>Brak statusów</div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: 'var(--gray-50)', borderBottom: '2px solid var(--gray-100)' }}>
                <th style={{ textAlign: 'left', padding: '10px 16px', fontSize: 12, fontWeight: 600, color: 'var(--gray-500)', textTransform: 'uppercase' }}>Podgląd</th>
                <th style={{ textAlign: 'left', padding: '10px 16px', fontSize: 12, fontWeight: 600, color: 'var(--gray-500)', textTransform: 'uppercase' }}>Klucz</th>
                <th style={{ textAlign: 'left', padding: '10px 16px', fontSize: 12, fontWeight: 600, color: 'var(--gray-500)', textTransform: 'uppercase' }}>Kolor</th>
                <th style={{ textAlign: 'left', padding: '10px 16px', fontSize: 12, fontWeight: 600, color: 'var(--gray-500)', textTransform: 'uppercase' }}>Typ</th>
                <th style={{ padding: '10px 16px', minWidth: 140 }}></th>
              </tr>
            </thead>
            <tbody>
              {statuses.map((s, i) => (
                <tr key={s.id} style={{ borderBottom: i < statuses.length - 1 ? '1px solid var(--gray-100)' : 'none' }}>
                  <td style={{ padding: '12px 16px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <div style={{ width: 16, height: 16, borderRadius: 4, background: s.color, border: '1px solid rgba(0,0,0,.1)', flexShrink: 0 }}/>
                      <span style={{
                        display: 'inline-flex', alignItems: 'center', gap: 5,
                        padding: '3px 10px', borderRadius: 20, fontSize: 12, fontWeight: 600,
                        background: s.color + '22', color: s.color, whiteSpace: 'nowrap'
                      }}>
                        {s.label}
                      </span>
                    </div>
                  </td>
                  <td style={{ padding: '12px 16px', fontSize: 13, color: 'var(--gray-500)', fontFamily: 'monospace' }}>{s.key}</td>
                  <td style={{ padding: '12px 16px', fontSize: 12, color: 'var(--gray-500)', fontFamily: 'monospace' }}>{s.color}</td>
                  <td style={{ padding: '12px 16px' }}>
                    <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 10,
                      background: s.is_system ? '#eff6ff' : '#f0fdf4',
                      color: s.is_system ? '#3b82f6' : '#16a34a', fontWeight: 600, whiteSpace: 'nowrap' }}>
                      {s.is_system ? 'Systemowy' : 'Własny'}
                    </span>
                  </td>
                  <td style={{ padding: '12px 16px', textAlign: 'right' }}>
                    <div style={{ display: 'flex', gap: 6, justifyContent: 'flex-end' }}>
                      <button className="btn btn-secondary btn-sm" onClick={() => openEdit(s)}>Edytuj</button>
                      {!s.is_system && (
                        <button className="btn btn-sm" onClick={() => del(s)}
                          style={{ background: '#fee2e2', color: '#dc2626', border: 'none' }}>Usuń</button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {showModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: 'white', borderRadius: 12, padding: 28, width: '100%', maxWidth: 420, boxShadow: '0 20px 60px rgba(0,0,0,.2)' }}>
            <h3 style={{ margin: '0 0 20px', fontSize: 17 }}>{editItem ? 'Edytuj status' : 'Nowy status'}</h3>
            <form onSubmit={save}>
              <div className="form-group" style={{ marginBottom: 16 }}>
                <label className="form-label">Nazwa statusu *</label>
                <input className="form-input" value={form.label} onChange={e => setForm(f => ({ ...f, label: e.target.value }))}
                  placeholder="np. W trakcie realizacji" required />
              </div>
              <div className="form-group" style={{ marginBottom: 20 }}>
                <label className="form-label">Kolor *</label>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  <input type="color" value={form.color} onChange={e => setForm(f => ({ ...f, color: e.target.value }))}
                    style={{ width: 48, height: 40, border: '1px solid var(--gray-200)', borderRadius: 8, cursor: 'pointer', padding: 2 }} />
                  <input className="form-input" value={form.color} onChange={e => setForm(f => ({ ...f, color: e.target.value }))}
                    placeholder="#3b82f6" style={{ fontFamily: 'monospace', flex: 1 }} />
                  <span style={{
                    display: 'inline-flex', alignItems: 'center', gap: 5,
                    padding: '4px 12px', borderRadius: 20, fontSize: 12, fontWeight: 600,
                    background: form.color + '22', color: form.color, whiteSpace: 'nowrap'
                  }}>
                    <span style={{ width: 6, height: 6, borderRadius: '50%', background: form.color }}/>
                    {form.label || 'Podgląd'}
                  </span>
                </div>
              </div>
              {editItem?.is_system && (
                <p style={{ fontSize: 12, color: 'var(--gray-400)', marginBottom: 16 }}>
                  ℹ️ Status systemowy — można zmienić nazwę i kolor, ale nie klucz ani kolejność przejść.
                </p>
              )}
              <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>Anuluj</button>
                <button type="submit" className="btn btn-primary" disabled={saving}>{saving ? 'Zapisuję...' : 'Zapisz'}</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
